export function initFooterInteractions(root = document) {
    const dropdowns = root.querySelectorAll('[data-footer-dropdown]');
    if (!dropdowns.length) return;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function closeDropdown(dropdown) {
        const toggle = dropdown.querySelector('[data-footer-dropdown-toggle]');
        const panel = dropdown.querySelector('[data-footer-dropdown-panel]');
        if (!toggle || !panel || !dropdown.classList.contains('is-open')) return;
        toggle.setAttribute('aria-expanded', 'false');
        dropdown.classList.remove('is-open');
        if (reduceMotion) {
            panel.hidden = true;
            panel.style.maxHeight = '';
            panel.style.opacity = '';
            return;
        }
        panel.style.maxHeight = `${panel.scrollHeight}px`;
        panel.style.opacity = '1';
        panel.offsetHeight;
        requestAnimationFrame(() => {
            panel.style.maxHeight = '0px';
            panel.style.opacity = '0';
        });
        window.setTimeout(() => {
            if (!dropdown.classList.contains('is-open')) {
                panel.hidden = true;
                panel.style.maxHeight = '';
                panel.style.opacity = '';
            }
        }, 300);
    }

    function openDropdown(dropdown) {
        const toggle = dropdown.querySelector('[data-footer-dropdown-toggle]');
        const panel = dropdown.querySelector('[data-footer-dropdown-panel]');
        if (!toggle || !panel || dropdown.classList.contains('is-open')) return;
        panel.hidden = false;
        panel.style.maxHeight = '0px';
        panel.style.opacity = '0';
        const fullHeight = panel.scrollHeight;
        toggle.setAttribute('aria-expanded', 'true');
        dropdown.classList.add('is-open');
        if (reduceMotion) {
            panel.style.maxHeight = 'none';
            panel.style.opacity = '1';
            return;
        }
        panel.offsetHeight;
        requestAnimationFrame(() => {
            panel.style.maxHeight = `${fullHeight}px`;
            panel.style.opacity = '1';
        });
        window.setTimeout(() => {
            if (dropdown.classList.contains('is-open')) {
                panel.style.maxHeight = 'none';
            }
        }, 300);
    }

    dropdowns.forEach((dropdown) => {
        const toggle = dropdown.querySelector('[data-footer-dropdown-toggle]');
        if (!toggle) return;
        toggle.addEventListener('click', (e) => {
            e.preventDefault();
            const isOpen = dropdown.classList.contains('is-open');
            dropdowns.forEach((item) => {
                if (item !== dropdown) {
                    closeDropdown(item);
                }
            });
            if (isOpen) {
                closeDropdown(dropdown);
            } else {
                openDropdown(dropdown);
            }
        });
    });
    document.addEventListener('click', (event) => {
        const target = event.target;
        if (!(target instanceof Element)) return;
        if (target.closest('[data-footer-dropdown]')) return;
        dropdowns.forEach((dropdown) => {
            closeDropdown(dropdown);
        });
    });
}
